import { AppBar, CssBaseline } from "@mui/material";

import GlobalStyle from "../../components/GlobalStyle";
import Navbar from "../../components/navbar/Navbar";
import "./LoginScreen.scss";
import LoginBox from "./components/loginBox/LoginBox";

const LoginScreen = () => {
  return (
    <div className="bp-root">
      {/* import of the used font */}
      <link rel="stylesheet" href="https://use.typekit.net/trt3hgk.css"></link>
      <CssBaseline />
      <GlobalStyle />
      <div className="app-content">
        <AppBar position="sticky" elevation={0}>
          <Navbar showAppName onDrawerToggle={() => {}} />
        </AppBar>
        <LoginBox />
      </div>
    </div>
  );
};

export default LoginScreen;
